import { checkFinalValue, translateError } from 'mmfintech-commons'
import { useState } from 'react'

export type BusinessWebsitesInputOutput = {
  errors: string[]
  values: string[]
  add: () => void
  remove: (index?: number) => void
  setValue: (index: number, value: string) => void
  setValues: (values: string[]) => void
  valid: () => boolean
}

export const useBusinessWebsitesInput = (): BusinessWebsitesInputOutput => {
  const [errors, setErrorsInternal] = useState<string[]>([''])
  const [values, setValuesInternal] = useState<string[]>([''])

  const add = () => {
    setErrorsInternal(prevState => [...prevState, ''])
    setValuesInternal(prevState => [...prevState, ''])
  }

  const remove = (index?: number) => {
    setValuesInternal(prevState => {
      const data = [...prevState]
      if (data.length > 1) {
        data.splice(index ?? data.length - 1, 1)
      }
      return data
    })
    setErrorsInternal(prevState => {
      const data = [...prevState]
      if (data.length > 1) {
        data.splice(data.length - 1, 1)
      }
      return data
    })
  }

  const setError = (index: number, error: string) => {
    setErrorsInternal(prevState => {
      const data = [...prevState]
      data[index] = error
      return data
    })
  }

  const setValue = (index: number, value: string) => {
    setError(index, '')
    setValuesInternal(prevState => {
      const data = [...prevState]
      data[index] = value
      return data
    })
  }

  const setValues = (values: string[]) => {
    setValuesInternal(values)
    setErrorsInternal(values.map(() => ''))
  }

  const valid = (): boolean => {
    let count = 0
    values.forEach((element, index) => {
      const check = checkFinalValue(element, { required: true, validation: 'safe-string' })
      if (!check.valid) {
        setError(index, translateError(check))
        count++
      }
    })
    return count === 0
  }

  return {
    errors,
    values,

    add,
    remove,
    setValue,
    setValues,
    valid
  }
}
